import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "trigger",
      description: "触发方式",
      type: "String",
      available: "hover, click",
      required: "是"
    },
    {
      prop: "noMargin",
      description: "设置reference与dropdown是否有距离",
      type: "Boolean",
      required: "否"
    },
    {
      prop: "placement",
      description:
        "dropdown位置，与popper.js配置一致，推荐使用bottom和bottom-start",
      type: "String",
      required: "是"
    },
    {
      prop: "mouseOutDelay",
      description: "隐藏dropdown的延迟(ms)",
      type: "Number",
      default: "100"
    },
    {
      prop: "mouseOverDelay",
      description: "触发dropdown的延迟(ms)",
      type: "Number",
      default: "10"
    },
    {
      prop: "disabled",
      description: "禁用",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "closeOnClick",
      description: "点击之后是否关闭",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "arrowVisible",
      description: "是否显示dropdown的箭头",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "arrow",
      description: "popperjs的arrow modifier",
      type: "Object"
    },
    {
      prop: "boundariesSelector",
      description: "dropdown进行边缘检测的对象",
      type: "String",
      default: "body"
    },
    {
      prop: "modifiers",
      description: "同popper.js",
      type: "Object"
    },
    {
      props: "customStyle",
      description: "自定义dropdown样式",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [],
  methods: [
    {
      name: "doToggle",
      description: "切换show和close"
    },
    {
      name: "doShow",
      description: "show"
    },
    {
      name: "doClose",
      description: "close"
    }
  ],
  slots: [
    {
      name: "reference",
      description: "基准元素"
    },
    {
      name: "dropdown",
      description: "dropdown元素"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
